import { store } from 'store/store';
import { ManualPaymentMethods } from './components/constants';
import { getPaymentMethodFilters } from 'containers/invoices/utils';

const { rootReducer } = store.getState();

const { app } = rootReducer;
const { brbClosureDate, faqMigrationMonthAndYear, faqMigrationSafeDate } = app.userDetails ?? {};

export const getBrbClosureDate = () => {
  return brbClosureDate || 'May 3rd, 2024';
};

export const getFaqMigrationSafeDate = () => {
  return faqMigrationSafeDate || 'April 30th, 2024';
};

export const getFaqMigrationMonthAndYear = () => {
  return faqMigrationMonthAndYear || 'May 2024';
};

export const calculatePercentageChange = (oldValue: number, newValue: number): string => {
  if (oldValue === newValue) return '0%';
  if (oldValue === 0) {
    return '+100%';
  }

  const difference = newValue - oldValue;
  const percentage = (difference / oldValue) * 100;

  if (difference > 0) {
    return `+${percentage.toFixed(2)}%`;
  } else if (difference < 0) {
    return `${percentage.toFixed(2)}%`;
  }
};

export const getPaymentMethodFromId = (paymentMethodId: string) => {
  let paymentMethod;
  paymentMethod = ManualPaymentMethods.find(item => item.key === paymentMethodId);
  if (!paymentMethod) {
    paymentMethod = getPaymentMethodFilters().find(item => item.key === paymentMethodId);
  }
  return paymentMethod?.value ?? paymentMethodId;
};
